/**
 * Tipos de documento de la plantilla: desplegable de selección múltiple con
 * «Seleccionar todos», agrupado por el esquema del SII de cada tipo (lo que
 * decide qué campos existen).
 */
import { MultiSelectField } from '@/components/ds/MultiSelectField'
import { TIPOS_DTE } from './geometria'

const OPCIONES = TIPOS_DTE.map(t => ({ value: t.code, label: `${t.code} · ${t.label}`, group: t.grupo }))

export function SelectorDeTipos({ value, onChange, disabled, error }: {
  value: number[]; onChange: (v: number[]) => void; disabled?: boolean; error?: string
}) {
  return (
    <MultiSelectField dense label="Tipos de documento" options={OPCIONES} value={value} onChange={onChange}
      disabled={disabled} error={error} allLabel="Todos los tipos" placeholder="Elegir los tipos de documento" />
  )
}
